import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InfoCategory } from '../../shared/models/app/info-category';
import { CartItem } from '../../shared/models/cart/cart';
import Checkout from '../../shared/models/checkout/checkout';
import CheckoutBudget from '../../shared/models/checkout/checkout-budget';
import Order from '../../shared/models/order/order';
import { Product } from '../../shared/models/product/product';
import { StorageConstants } from '../../shared/models/storage/storage-constants';
import { AppInfoService } from '../app-info/app-info.service';
import { HttpService } from '../http/http.service';
import { SessionStorageService } from '../session-storage/session-storage.service';

@Injectable({
  providedIn: 'root',
})
export class TransactionsService {
  constructor(
    private appInfoService: AppInfoService,
    private httpService: HttpService,
    private sessionStorageService: SessionStorageService
  ) {}

  public checkout(checkout: Checkout): Promise<Order> {
    return new Promise((resolve, reject) => {
      this.httpService.post(`transactions/checkout/`, checkout).subscribe({
        next: async (res: any) => {
          await this.sessionStorageService.removeItem(
            StorageConstants.RM_ECOMMERCE_FREIGHT
          );
          const categories: InfoCategory[] =
            await this.appInfoService.getCategories();

          let newCartProducts: CartItem[] = [];
          const order = Object.assign(new Order(), res);

          order.cartProducts.forEach((item: any) => {
            let product: Product;
            product = new Product();
            product.fromJson(item.product, categories);
            const cartItem: CartItem = { ...item, product };
            newCartProducts.push(cartItem);
          });
          order.cartProducts = newCartProducts;
          resolve(order);
        },
        error: (error: any) => {
          const msg =
            error?.error?.message ||
            error?.error?.error ||
            'Ocorreu um erro ao realizar seu pagamento. Entre em contato com a loja!';
          reject(msg);
        },
      });
    });
  }

  public checkoutSimplified(checkout: Checkout): Promise<Order> {
    return new Promise((resolve, reject) => {
      this.httpService
        .post(`transactions/simplified/checkout/`, checkout)
        .subscribe({
          next: async (res: any) => {
            await this.sessionStorageService.removeItem(
              StorageConstants.RM_ECOMMERCE_FREIGHT
            );
            const categories: InfoCategory[] =
              await this.appInfoService.getCategories();

            let newCartProducts: CartItem[] = [];
            const order = Object.assign(new Order(), res);

            order.cartProducts.forEach((item: any) => {
              let product: Product;
              product = new Product();
              product.fromJson(item.product, categories);
              const cartItem: CartItem = { ...item, product };
              newCartProducts.push(cartItem);
            });
            order.cartProducts = newCartProducts;
            resolve(order);
          },
          error: (error: any) => {
            const msg =
              error?.error?.message ||
              error?.error?.error ||
              'Ocorreu um erro ao realizar seu pagamento. Entre em contato com a loja!';
            reject(msg);
          },
        });
    });
  }

  public checkoutBudget(checkout: CheckoutBudget): Promise<Order> {
    return new Promise((resolve, reject) => {
      this.httpService
        .post(`transactions/budget/checkout/`, checkout)
        .subscribe({
          next: async (res: any) => {
            const categories: InfoCategory[] =
              await this.appInfoService.getCategories();

            let newCartProducts: CartItem[] = [];
            const order = Object.assign(new Order(), res);

            order.cartProducts.forEach((item: any) => {
              let product: Product;
              product = new Product();
              product.fromJson(item.product, categories);
              const cartItem: CartItem = { ...item, product };
              newCartProducts.push(cartItem);
            });
            order.cartProducts = newCartProducts;
            resolve(order);
          },
          error: (error: any) => {
            const msg =
              error?.error?.message ||
              error?.error?.error ||
              'Ocorreu um erro ao realizar seu pagamento. Entre em contato com a loja!';
            reject(msg);
          },
        });
    });
  }

  public statusPix(idOrder: number): Promise<boolean> {
    const headers = new HttpHeaders({
      'no-loader': 'no-loader',
    });

    return new Promise((resolve, reject) => {
      this.httpService
        .get(
          `transactions/status?orderId=${idOrder}`,
          {} as HttpParams,
          headers
        )
        .subscribe({
          next: (res: any) => {
            resolve(res);
          },
          error: (error: any) => {
            const msg =
              error?.error?.message ||
              error?.error?.error ||
              'Ocorreu um erro ao buscar o status do PIX!';
            reject(msg);
          },
        });
    });
  }
}
